import React, { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function SendIcon({ dark = false, ...props }: Props) {
  const { palette }: Theme = useTheme();

  const contrastForeground = dark ? palette.secondary.lightest : palette.proceed.main;

  const foreground = contrastForeground;

  return (
    <SvgIcon {...props} viewBox="0 0 24 23">
      <path
        fill={foreground}
        d="M22.5.7C21.9.2 21 0 20.3.2L2.5 5.4C1.7 5.6 1 6.2.9 7c-.1.9.4 2 1.2 2.4l5.5 3.4c.6.4 1.3.3 1.8-.2l6.4-6.4c.3-.4.9-.4 1.2 0 .3.3.3.8 0 1.1l-6.4 6.5c-.5.4-.6 1.2-.2 1.8l3.4 5.6c.4.7 1 1 1.8 1h.3c.9 0 1.5-.7 1.8-1.5L23 2.9c.2-.8 0-1.6-.5-2.2z"
      />
    </SvgIcon>
  );
}

export default memo(SendIcon);
